import loginToken from "../authComponents/localStorageItems/LoginTokin";
import baseURL from "../authComponents/baseURL/BaseURL";
import { authSliceActions } from "../../redux/slices/authSlice"
import Swal from "sweetalert2";
import { useState } from "react";

import {
  FaHeart,
  FaBirthdayCake,
  FaMapMarkerAlt,
  FaPrayingHands,
  FaUserGraduate,
  FaPencilAlt,
  FaEyeSlash
} from "react-icons/fa";
import { IoCloseCircleSharp } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Helper function to format strings from snake_case to Title Case
const getProperString = (string) => {
  if (!!string) {
    return string
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    return "--";
  }
};

const ProfileCard = ({ profile, includeActions, onStatusChange = null }) => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Check if name should be hidden
  const shouldHideName = profile.show_name === "show_no";
  
  const handleViewProfle = async () => {
    if (!loginToken) {
      navigate("/login");
    }

    try {
      const response = await baseURL.get(`/profile`, {
        headers: {
          Authorization: `Bearer ${loginToken}`,
        },
      });
      dispatch(authSliceActions.getStatus(response.data.data.status));
    } catch (error) {
      if (error.status === 401) {
        localStorage.removeItem("authToken");
        window.location.reload();
      }
      // console.error(
      //   "Error fetching profile:",
      //   error.response?.data || error.message
      // );
    }
  };

    const handleStatusChange = async (userId, newStatus) => {
      if (newStatus.toLowerCase() === 'rejected') {
        Swal.fire({
          title: 'Please enter Rejection reasons',
          input: 'textarea',
          inputPlaceholder: 'Title not correct...',
          inputAttributes: {
            'aria-label': 'Rejection reason'
          },
          customClass: {
            title: 'swal-title-arial',
            input: 'swal-input-arial',
            popup: 'swal-popup-arial'
          },
          showCancelButton: true,
          confirmButtonText: 'Confirm Rejection',
          cancelButtonText: 'Cancel',
        }).then((result) => {
          if (result.isConfirmed && result.value && result.value.trim() !== '') {
            const rejectionReason = result.value;
            updateUserStatus(userId, newStatus, rejectionReason)
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Rejection Failed',
              text: 'Rejection reasons are required for rejection of account.',
              confirmButtonText: 'Okay',
              customClass: {
                title: 'swal-title-arial',
                popup: 'swal-popup-arial'
              }
            });
          }
        });
      } else {
        updateUserStatus(userId, newStatus)
      }
    };

  const updateUserStatus = async (userId, newStatus, rejectionReason = null) => {
    try {
      const respone = await baseURL.post(
        "/admin/users/update_status",
        { id: userId, status: newStatus, rejection_reason: rejectionReason },
        { headers: { Authorization: `Bearer ${loginToken}` } }
      );
      // Update local state to reflect the new status
      if (respone.status == 200) {
        onStatusChange(userId);
        toast.success(respone.data.message);
      } else {
        console.error("Failed to update user status:");
      }
    } catch (error) {
      console.error(error)
    }
  }

  const deleteUser = async (user) => {
    try {
      const delete_response = await baseURL.post(
        "/admin/users/delete_user",
        { id: user.id },
        { headers: { Authorization: `Bearer ${loginToken}` } }
      );

      if (delete_response.status == 200) {
        toast.success("Profile deleted successfully");
        onStatusChange(user.id);
      }
    } catch (error) {
      console.error("Failed to delete user:", error);
    }
  }

  function getTitle(title = "--") {
    const wordsToReplace = ['almost', 'about', 'over', 'around', 'more than', 'less than'];
    let formatted = title.toLowerCase();

    wordsToReplace.forEach(word => {
      const regex = new RegExp(`\\b${word}\\b`, 'gi');
      formatted = formatted.replace(regex, 'Joined');
    });
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
    return formatted
  }

  return (
    <>

      <div className="overflow-hidden border border-[#730000] rounded-lg shadow-lg shadow-[#730000] p-4 md:p-2 min-w-[30%]">
        {/* Profile Header */}
        <div className="flex row justify-between mb-2">
          <span className="bg-gray-100 text-white text-xs font-medium inline-flex items-center px-1 py-0.5 rounded-sm me-2 border border-gray-500 " style={{ fontSize: "10px", fontFamily: "arial", backgroundColor: "rgb(55, 65, 81)", color: "white" }}>
            <svg className="w-2.5 h-2.5 me-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm3.982 13.982a1 1 0 0 1-1.414 0l-3.274-3.274A1.012 1.012 0 0 1 9 10V6a1 1 0 0 1 2 0v3.586l2.982 2.982a1 1 0 0 1 0 1.414Z" />
            </svg>
            {
              getTitle(profile.created_on)
            }
          </span>
          <span className="bg-pink-100 text-white text-sm font-medium me-2 px-2 py-0.5 rounded-full" style={{ fontSize: "10px", fontFamily: "arial", backgroundColor: "rgb(131, 24, 67)", color: "white" }}> ID: {profile.id}</span>
        </div>
        <div className="flex items-start w-[100%] gap-2 space-x-4 max-lg:space-x-0">
          <div className="!w-[25%] max-lg:!w-[20%] avatar-img-container">
            <img
              src={
                profile.main_image ||
                  profile.gender === "female"
                  ? "https://static.vecteezy.com/system/resources/previews/029/271/069/non_2x/avatar-profile-icon-in-flat-style-female-user-profile-illustration-on-isolated-background-women-profile-sign-business-concept-vector.jpg"
                  : profile.gender === "male"
                    ? "https://static.vecteezy.com/system/resources/previews/029/271/062/non_2x/avatar-profile-icon-in-flat-style-male-user-profile-illustration-on-isolated-background-man-profile-sign-business-concept-vector.jpg"
                    : profile.main_image ||
                    "https://static.vecteezy.com/system/resources/previews/029/271/062/non_2x/avatar-profile-icon-in-flat-style-male-user-profile-illustration-on-isolated-background-man-profile-sign-business-concept-vector.jpg"
              }
              alt="profile"
              className=" min-w-[100%] rounded-full  avatar-img"
            />
          </div>

          <div className=" w-[70%] text-left text-left-container">
            <div className="w-[100%] flex flex-row justify-between items-center mb-1">
              {shouldHideName ? (
                <div className="flex w-full items-center space-x-2">
                  <p className="text-gray-500 max-sm:text-[16px] text-[18px] font-semibold italic" >
                    Name Hidden
                  </p>
                  <FaEyeSlash className="text-gray-500" />
                </div>
              ) : (
                <p className="text-[#730000] font-semibold max-sm:text-[16px] text-[18px] " >
                  {profile.first_name} {profile.last_name}
                </p>
              )}
              
              {includeActions && <div className="flex row items-center space-x-2">
                <a href={`/edit-profile?act_as_admin_for_user=${profile.id}`} target="_blank" className="flex row items-center gap-2 mt-3">
                  <FaPencilAlt className="text-gray-500 cursor-pointer" />
                </a>
              </div>}
            </div>
            <p className="text-gray-600 cursor-pointer  max-sm:w-full line-clamp-3 max-md:text-[0.9rem] overflow-hidden" onClick={() => setShowPopup(true)}>
              {profile.title}
            </p>
          </div>
        </div>
        <div className="flex justify-center">
          {!includeActions && <Link
            to={`/profile-details/${profile.id}`}
            onClick={handleViewProfle}>
            <button className="bg-[#730000] text-white px-2 py-1 rounded mt-4 max-sm:w-32 px-5">
              Full Profile
            </button>
          </Link>}

          {includeActions && <div className="flex flex-row items-center mt-0 max-md:mt-0 lg:gap-1.5 gap-1">
            <button onClick={() => handleStatusChange(profile.id, "rejected")} className="bg-[#730000] text-white max-sm:px-1.5 px-4 py-1 rounded mt-4">
              Reject
            </button>
            <button onClick={() => handleStatusChange(profile.id, "active")} className="bg-green-600 text-white max-sm:px-1.5 px-4 py-1 rounded mt-4">
              Accept
            </button>

            <button onClick={() => deleteUser(profile)} className="bg-red-600 text-white max-sm:px-1.5 px-4 py-1 rounded mt-4">
              Delete
            </button>
            <a href={`/profile-details/${profile.id}`} target="_blank" className="bg-blue-600 text-white max-sm:px-1.5 px-4 py-1 rounded mt-4">
              Details
            </a>
          </div>}
        </div>

        {/* Profile Details */}
        <div className="flex justify-center w-full">
          <div className="flex flex-wrap justify-between mt-4 gap-4 text-gray-700 self-end w-[90%]">
            {/* Marital Status and Age */}
            <div className="grid grid-cols-2 w-full">
              <div className="w-[45%">
                <div className="flex items-center space-x-2">
                  <FaHeart className="text-pink-500 w-4 h-4" />
                  <p className="max-lg:text-[0.9rem]">{getProperString(profile.marital_status)}</p>
                </div>
              </div>
              <div className="w-[35%">
                <div className="flex items-center space-x-2">
                  <FaBirthdayCake className="text-pink-500 w-4 h-4" />
                  <p className="max-lg:text-[0.9rem]">{profile.age || "N/A"}</p>
                </div>
              </div>
            </div>

            {/* Location */}
            <div className="grid grid-cols-2 w-full">
              <div className="w-[45%">
                <div className="flex items-center space-x-2">
                  <FaMapMarkerAlt className="text-pink-500 w-4 h-4" />
                  <p className="max-lg:text-[0.9rem] leading-none">{profile.city || "City N/A"}</p>
                </div>
              </div>
              <div className="w-[35%">
                <div className="flex items-center space-x-2">
                  <FaMapMarkerAlt className="text-pink-500 w-4 h-4" />
                  <p className="max-lg:text-[0.9rem] leading-none">{profile.country || "Country N/A"}</p>
                </div>
              </div>
            </div>

            {/* Religion and Gender */}
            <div className="grid grid-cols-2 w-full">
              <div className="w-[45%">
                <div className="flex items-center space-x-2">
                  <FaPrayingHands className="text-pink-500 w-4 h-4" />
                  <p className="max-lg:text-[0.9rem] leading-none">{getProperString(profile.religion)}</p>
                </div>
              </div>
              {/* <div className="flex items-center space-x-2">
              <FaUser className="text-pink-500" />
              <p>{getProperString(profile.gender)}</p>
            </div> 

            {/* Profession */}
              <div className="w-[35%">
                <div className="flex items-center space-x-2">
                  <FaUserGraduate className="text-pink-500 w-4 h-4" />
                  <p className="max-lg:text-[0.9rem] leading-none">{getProperString(profile.occupation)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white flex flex-col p-3 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex flex-row justify-between">
              <p>&nbsp;</p>
              <IoCloseCircleSharp style={{ fontSize: "30px" }} className="cursor-pointer" onClick={() => { setShowPopup(false) }} />
            </div>
            <div className="text-center">
              <center>
                <h4 style={{ fontFamily: "serif", fontSize: "18px" }}>
                  {shouldHideName ? "Name Hidden" : `${profile.first_name} ${profile.last_name}`}
                </h4>
              </center>
              <hr />
              <p className="mt-2 text-sm text-gray-500 p-4">
                {profile.title || "No title available"}
              </p>
              {/* <div className="mt-4">
            <p className="text-sm text-gray-500">
              Redirecting to homepage...
            </p>
          </div> */}
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default ProfileCard;